import {
    SimplePresentation,
    SimplePresentationRunnerController
} from "../../core/winpresentation/SimplePresentationRunner";
import {gsap} from "gsap";
import {HTH} from "../HTH";
import {HTHSound} from "../sound/HTHSound";

export class HTHWinCapPresentation implements SimplePresentation {
    name: string = "WinCapPresentation";

    shouldRun(): boolean {
        return HTH.model.brokeTheBank;
    }

    start(controller: SimplePresentationRunnerController): void {
        const startWinCapTL: gsap.core.Timeline = gsap.timeline();
        HTH.keypadPlugin.setZeroBetSpinCounter(-1);

        startWinCapTL.add(() => {
            HTHSound.playTrack(HTHSound.BIGWIN_INTRO);
            HTHSound.fadeMusic(0, 0.01);
        })
        startWinCapTL.add(HTH.gameViewContainer.shakeEffect(0.5, 150, true, 15), 0);
        startWinCapTL.add(HTH.gameViewContainer.addOverlay(0.2, 0.7), 0.3);
        startWinCapTL.add(HTH.winCapView.showWinCap());
        startWinCapTL.add(() => {
            controller.setSkipCallback(() => {
                HTHSound.stopSound(HTHSound.CAPWIN_COUNTUP);
                startWinCapTL.seek("countupCompleted", false);
            });
        }, 0.5);
        startWinCapTL.addLabel("countupCompleted");
        startWinCapTL.add(HTH.winCapView.playFireEffect());
        startWinCapTL.add(() => {
            controller.setSkipCallback();
        });
        startWinCapTL.add(HTH.transitionView.enableButton(() => this.complete(controller)));
    }

    public complete(controller: SimplePresentationRunnerController): void {
        const endWinCapTL: gsap.core.Timeline = gsap.timeline();
        endWinCapTL.add(() => {
            HTHSound.stopSound(HTHSound.CAPWIN_LOOP);
            HTHSound.playTrack(HTHSound.CAPWIN_END);
            HTHSound.fadeMusic(1, 1500);
            HTHSound.switchMusic({name: HTHSound.MAIN_GAME_MUSIC});
        }, 0);
        endWinCapTL.add(HTH.winCapView.hideWinCap(), 0);
        endWinCapTL.add(() => {
            controller.setSkipCallback();
            controller.finish();
        });
    }
}